import React, { useEffect, useRef, useState } from "react";

const zonderPunt = (s) => s.replace(/\./g, "");
export const tijdLabel = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  const hm = d.toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });
  return `${zonderPunt(d.toLocaleDateString("nl-NL", { weekday: "short" }))} ${d.getDate()} ${zonderPunt(d.toLocaleDateString("nl-NL", { month: "short" }))} ${hm}`;
};
const nuHM = () => new Date().toLocaleTimeString("nl-NL", { hour: "2-digit", minute: "2-digit" });

// v15 A2: één antwoordveld (deadline of peilmoment): tekst + Opslaan (ook bij blur) + Gereed.
export function AntwoordVeld({ rep, onSave, onToggle, ids }) {
  const saved = rep.note || "";
  const [text, setText] = useState(saved);
  const [opgeslagen, setOpgeslagen] = useState("");
  const laatst = useRef(saved);
  const bezig = useRef(false);
  const mislukt = useRef(false);
  const onderweg = useRef(null);
  const ta = useRef(null);
  const tekst = useRef(text);
  tekst.current = text;

  useEffect(() => {
    const prev = laatst.current;   // R8c: eerst vastleggen, de updater draait later
    setText((t) => (t === prev ? saved : t));
    laatst.current = saved;
  }, [saved]);
  useEffect(() => {
    const el = ta.current;
    if (el) { el.style.height = "auto"; el.style.height = `${el.scrollHeight}px`; }
  }, [text]);
  useEffect(() => () => { if (!mislukt.current && tekst.current !== laatst.current && tekst.current !== onderweg.current) onSave(tekst.current); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const opslaan = async () => {
    const t = tekst.current;
    if (bezig.current || t === laatst.current) return;
    bezig.current = true;
    onderweg.current = t;   // R8a: blur + route-wissel → geen tweede PATCH met dezelfde tekst
    const ok = await onSave(t);
    bezig.current = false;
    onderweg.current = null;
    mislukt.current = !ok;
    if (ok) { laatst.current = t; setOpgeslagen(nuHM()); }
  };
  const dirty = text !== laatst.current;
  return (
    <div className="mt-1">
      <textarea ref={ta} rows={2} data-testid={ids.note} value={text} placeholder="Wat is de stand van zaken?"
        onChange={(e) => { mislukt.current = false; setText(e.target.value); }} onBlur={opslaan}
        className="w-full text-base leading-snug px-2.5 py-1.5 rounded-md border border-zinc-300 bg-white resize-none overflow-hidden focus:outline-none focus:ring-2 focus:ring-blue-500 text-zinc-800" />
      <div className="mt-1 flex flex-wrap items-center gap-x-4 gap-y-1">
        <label className="inline-flex items-center gap-2 min-h-[44px] sm:min-h-0 text-sm text-zinc-700 cursor-pointer">
          <input type="checkbox" checked={!!rep.reported} onChange={onToggle} data-testid={ids.gereed} className="h-4 w-4 rounded-sm accent-blue-600" />
          Gereed
        </label>
        <button type="button" data-testid={ids.opslaan} disabled={!dirty} onMouseDown={(e) => e.preventDefault()} onClick={opslaan}
          className="min-h-[44px] sm:min-h-0 px-3 py-1 rounded-md bg-zinc-950 text-white text-xs font-semibold transition-colors hover:bg-zinc-800 disabled:bg-zinc-200 disabled:text-zinc-400">
          Opslaan
        </button>
        {opgeslagen ? <span data-testid={`${ids.opslaan}-opgeslagen`} className="text-xs text-emerald-700">Opgeslagen om {opgeslagen}</span>
          : rep.at && saved ? <span data-testid={`${ids.opslaan}-bijgewerkt`} className="text-xs text-zinc-500">Laatst bijgewerkt {tijdLabel(rep.at)}</span> : null}
      </div>
    </div>
  );
}

// Afgehandeld: alleen lezen.
export function AntwoordLezen({ rep, testid }) {
  if (!rep || !(rep.reported || (rep.note || "").trim())) return null;   // R8e: oude kaarten konden nog niet antwoorden
  return (
    <div data-testid={testid} className="mt-0.5 text-sm text-zinc-700">
      {(rep.note || "").trim() && <p className="whitespace-pre-line break-words">{rep.note}</p>}
      <p className="text-xs text-zinc-500">{rep.reported ? "Gereed · " : ""}{rep.at ? tijdLabel(rep.at) : ""}</p>
    </div>
  );
}
